module.exports = __webpack_public_path__ + "img/icon_wulian.1d5a9374.png";